import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './langs/en'
import tr from './langs/tr'


Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: localStorage.getItem('_aiLocale')?localStorage.getItem('_aiLocale'):'tr',
    fallbackLocale : 'en',
    messages:{
        tr : tr,
        en : en
    }
});



// WEBPACK FOOTER //
// ./src/plugins/i18n.js